var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c(require(`@/assets/images/${_vm.name}.svg?inline`),{tag:"component",class:_vm.disabled ? _vm.name + '_disabled' : ''})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }